import React, { useState, useEffect } from 'react';

// Custom hook for responsive breakpoints
const useResponsive = () => {
  const [screenWidth, setScreenWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : 1200);

  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  return {
    screenWidth,
    isMobile: screenWidth < 640,
    isTablet: screenWidth >= 640 && screenWidth < 1024,
    isDesktop: screenWidth >= 1024,
    isSmall: screenWidth < 375,
    isLarge: screenWidth >= 1440
  };
};

const Schedule = () => {
  const { isMobile, isTablet, isDesktop, isSmall } = useResponsive();

  const scheduleData = [
    { day: 'MONDAY', time: '2200-0000' },
    { day: 'TUESDAY', time: '2000-2300' },
    { day: 'WEDNESDAY', time: '2100-0100' },
    { day: 'THURSDAY', time: '2000-2300' },
    { day: 'FRIDAY', time: '2100-0200' },
    { day: 'SATURDAY', time: '2200-0300' }
  ];

  const getScheduleStyles = () => ({
    container: {
      width: '100%',
      backgroundColor: '#000000',
      padding: isMobile ? '40px 16px' : isTablet ? '60px 24px' : '80px 32px',
      minHeight: isMobile ? 'auto' : '500px',
      boxSizing: 'border-box'
    },
    wrapper: {
      maxWidth: '1280px',
      margin: '0 auto',
      width: '100%'
    },
    scheduleList: {
      display: 'flex',
      flexDirection: 'column',
      gap: '0',
      width: '100%'
    },
    scheduleItem: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      padding: isMobile ? '20px 0' : isTablet ? '24px 0' : '28px 0',
      borderBottom: '1px solid #333333',
      transition: 'all 0.3s ease',
      width: '100%',
      boxSizing: 'border-box'
    },
    scheduleItemHover: {
      backgroundColor: 'rgba(255, 255, 255, 0.02)',
      borderBottomColor: '#555555',
      transform: 'translateX(8px)'
    },
    day: {
      fontSize: isSmall ? '16px' : isMobile ? '18px' : isTablet ? '20px' : '22px',
      fontWeight: '700',
      color: '#FFFFFF',
      textTransform: 'uppercase',
      letterSpacing: isMobile ? '0.5px' : '1px',
      margin: 0,
      flex: 1
    },
    time: {
      fontSize: isSmall ? '14px' : isMobile ? '16px' : isTablet ? '18px' : '20px',
      fontWeight: '500',
      color: '#888888',
      letterSpacing: isMobile ? '0.3px' : '0.8px',
      fontFamily: 'monospace',
      textAlign: 'right'
    },
    title: {
      fontSize: isSmall ? '24px' : isMobile ? '28px' : isTablet ? '36px' : '42px',
      fontWeight: '900',
      color: '#FFFFFF',
      textTransform: 'uppercase',
      letterSpacing: isMobile ? '1px' : '2px',
      marginBottom: isMobile ? '32px' : isTablet ? '40px' : '48px',
      textAlign: 'center',
      textShadow: '2px 2px 8px rgba(0,0,0,0.7)'
    },
    subtitle: {
      fontSize: isSmall ? '12px' : isMobile ? '14px' : isTablet ? '16px' : '18px',
      fontWeight: '600',
      color: '#666666',
      textTransform: 'uppercase',
      letterSpacing: isMobile ? '0.5px' : '1px',
      marginBottom: isMobile ? '24px' : '32px',
      textAlign: 'center'
    }
  });

  const styles = getScheduleStyles();

  return (
    <div style={styles.container}>
      <div style={styles.wrapper}>
        <h2 style={styles.title}>
          LIVE SCHEDULE
        </h2>
        <p style={styles.subtitle}>
          Catch us live during these hours
        </p>
        
        <div style={styles.scheduleList}>
          {scheduleData.map((item, index) => {
            // eslint-disable-next-line react-hooks/rules-of-hooks
            const [isHovered, setIsHovered] = React.useState(false);
            
            return (
              <div
                key={index}
                style={{
                  ...styles.scheduleItem,
                  ...(isHovered ? styles.scheduleItemHover : {})
                }}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <h3 style={styles.day}>
                  {item.day}
                </h3>
                <span style={styles.time}>
                  {item.time}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default Schedule;